import { DtoMessageDiscountRequest } from 'src/app/types/discountRequest/DtoMessageDiscountRequest';
import { httpClient } from '../httpClient';

export async function get() {
  const { data } = await httpClient.get<DtoMessageDiscountRequest>('api/v1/solicitacaodesconto');

  return data;
}
